import * as React from "react";
import SSOAuth from "./ssoauth";
import BasicLogin from "./basicLogin";
import { useSelector } from "react-redux";

import { Box, Typography, Divider } from "@mui/material";

export default function Login() {
  const system = useSelector((state) => state.systemReducer);

  return (
    <div className={"app-login-form-wrapper"}>
      <div id="login-screen-wrapper" className="login-screen-wrapper">
        <div className="logo-wrapper">
          {/* <img src="./assets/ca-logo-pwa.png" /> */}
          <img src="./assets/ca-logo-pwa.png" />
        </div>
        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
          <Typography variant="h5" sx={{ color: "#16324f", fontWeight: "600" }}>
            Login
          </Typography>
          <Divider sx={{ width: 0.8, margin: "10px 0 20px" }} />
        </Box>
      </div>
      {system.type === "sso" && <SSOAuth />}
      {system.type === "basic" && <BasicLogin />}
    </div>
  );
}
